//
// Module for common Taxability Step in Benefit Setup wizards
//
rs.module("participant/benefit/setup/common/wizard/taxabilitystep",

    ["common/visibility", "common/select-helper", "controls/components/event-banner"],

    function (visibility, selectHelper, eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, backendUrls, variables) {

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var applyStateWithholdingCheckBox = stepContainer.js(jsSelectors.applyStateWithholdingCheckBox);
            var stateContainer = stepContainer.js(jsSelectors.stateContainer);
            var stateSelect = stepContainer.js(jsSelectors.stateSelect);

            // Get Select Helper for stateSelect since we're updating its options and properties
            var stateSelectHelper = selectHelper.getHelper(stateSelect);

            // Conditionally display and populate State on applyStateWithholdingCheckBox change
            applyStateWithholdingCheckBox.change(function () {

                eventBanner.removeAllMessages();

                if (this.checked) {

                    // clear any stateSelect validation errors
                    stateSelect.clearErrors();

                    // re-populate states
                    stateSelectHelper.loadOptionsFrom(
                        backendUrls.getWithholdingValidStatesAsync,
                        {
                            effectiveDate: variables.benefitEffectiveDate
                        });   
                }

                visibility.setVisible(stateContainer, this.checked);
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);